











import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { IObjectsControllable, ILinkedPageObjectSpecifiable, TextObjectKinds, DateObjectKinds } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { FormatObjectSelectorColumnTypes } from "../../../../../formatEditor/components/format/editors/contents/commonComponents/selectors";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";
import { TextObjectEditor, DateObjectEditor } from "../../../../../formatEditor/domain/editableFormat/objectEditors";

@Component
export default class ItemSelectTriggerBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IObjectsControllable<ILinkedPageObjectSpecifiable>) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IObjectsControllable<ILinkedPageObjectSpecifiable>) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get targets(): ILinkedPageObjectSpecifiable[] {
    return this.readPropertyOrDefault(s => s.targets, []);
  }

  set targets(value: ILinkedPageObjectSpecifiable[]) {
    this.writePropertyWhenValid(s => s.targets = value);
  }

  get selectionObjects(): ILinkedPageObjectSpecifiable[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjectsForEachPage)
      .selectMany(p => Enumerable.from(p.objects)
        .where(o => this.conditionsOfEachElementType(o))
        .select(o => this.toLinkedPageObjectSpecifiable(o, p.pageKey))
        .toArray())
      .toArray();
  }

  private conditionsOfEachElementType(object: IFormatObjectEditable): boolean {
    const linkedObject = object.toLinkedObjectIdentifier();
    return ((object.objectTypeName().getValue() === "text" && object instanceof TextObjectEditor && object.objectKind().getValue() === TextObjectKinds.UserDefined) ||
      (object.objectTypeName().getValue() === "date" && object instanceof DateObjectEditor && object.objectKind().getValue() === DateObjectKinds.UserDefined)) &&
      !!linkedObject.id &&
      !!linkedObject.key &&
      linkedObject.key !== "";
  }

  private toLinkedPageObjectSpecifiable(object: IFormatObjectEditable, pageKey: number): ILinkedPageObjectSpecifiable {
    const linkedObject = object.toLinkedObjectIdentifier();
    return {
      pageKey: pageKey,
      type: linkedObject.type,
      id: linkedObject.id,
      key: linkedObject.key,
      subKey: linkedObject.subKey,
      tableIndex: linkedObject.tableIndex,
      isDate: linkedObject.isDate,
    };
  }

  async showItemSelectTriggerEditDialog() {
    const dialog = this.commonComponents.getDialogs().getFormatObjectSelectDialog();
    const targets = await dialog.show(
      this.targets,
      this.selectionObjects,
      ["selection", "key", "id", "pageNumber"],
      ["selection", "key", "id", "pageNumber"],
      true,
      false,
      [
        { enabled: false, name: "テキスト", description: "テキストで絞り込みします", filter: v => v.type === "text" },
        { enabled: false, name: "日付", description: "日付で絞り込みします", filter: v => v.type === "date" && v.isDate === true },
      ],
      this.toCellString);
    if (!targets) { return; }
    this.targets = targets;
  }

  private toCellString(column: FormatObjectSelectorColumnTypes, row: ILinkedPageObjectSpecifiable): string {
    switch (column) {
      case "id":
        return row.id ? row.id.toString() : "";
      case "key":
        return row.key;
      case "pageNumber":
        const pageNumber = this.commonComponents.getPageNumber(row.pageKey);
        return pageNumber === 0 ? "削除済" : pageNumber.toString();
      default:
        return "";
    }
  }
}
